'use es6';

import $ from 'jquery';
export const previewScrollTop = () => $(document).scrollTop();
export const previewDocumentHeight = () => $(document).height();
export const previewBodyHeight = () => $('body').outerHeight(true);